import { Component, ViewChild, AfterViewInit, Output, EventEmitter } from '@angular/core';
import { Location } from '../../context-discovery-services/models/location.model';
import { SpatialAssetService } from '../../context-discovery-services/services';
import * as _ from 'lodash';

@Component({
  selector: 'adminapp-assign-location',
  templateUrl: './assign-location.component.html',
  styleUrls: ['./assign-location.component.scss']
})
export class AssignLocationComponent implements AfterViewInit {

  listOfLocation: Array<Location>;
  isErrorOccurred: boolean;
  isGetLocationsInProgress: boolean;
  modelId: string;
  createLocationId: string = 'createLocation';
  selectLocationId: string = 'selectLocation';

  @ViewChild('locationNameInput') locationNameInput: any;
  @ViewChild('locationListSelect') locationListSelect: any;
  @ViewChild('modeOfLocationAssignmentGroup') modeOfLocationAssignmentGroup: any;
  @ViewChild('assignLocationButton') assignLocationButton: any;
  @ViewChild('retrieveLocationsButton') retrieveLocationsButton: any;
  @ViewChild('assignLocationDialog') assignLocationDialog: any;
  @ViewChild('locationList') locationList: any;

  @Output()
  locationToBeAssignedSuccessEmitter: EventEmitter<Location> = new EventEmitter<Location>();

  constructor(private spatialAssetService: SpatialAssetService) {
  }

  open(idOfModel: string) {
    if (this.locationNameInput) {
      this.locationNameInput.nativeElement.value = '';
    }
    if (this.locationListSelect) {
      this.locationListSelect.nativeElement.value = null;
      this.locationListSelect.nativeElement._markOption(null, false);
    }
    if (this.modeOfLocationAssignmentGroup) {
      this.modeOfLocationAssignmentGroup.nativeElement.selected = this.selectLocationId;
    }
    this.retrieveLocations(idOfModel);
    this.modelId = idOfModel;
    this.assignLocationDialog.nativeElement.open();
  }

  retrieveLocations(idOfModel: string) {
    this.listOfLocation = [];
    this.isErrorOccurred = false;
    if (idOfModel) {
      this.isGetLocationsInProgress = true;
      this.spatialAssetService.listLocations(idOfModel).subscribe(
        this.getLocationsSuccessCallBack.bind(this), this.getLocationsFailureCallback.bind(this));
    } else {
      this.loadLocationListNativeElement(false, true);
    }
  }

  getLocationsSuccessCallBack(locations: Array<Location>) {
    this.listOfLocation = _.sortBy(locations, location => location.label);
    this.loadLocationListNativeElement(false);
  }

  getLocationsFailureCallback() {
    this.loadLocationListNativeElement(true);
  }

  emitLocationToBeAssignedEvent() {
    if (this.modeOfLocationAssignmentGroup.nativeElement.selected === this.createLocationId) {
      const newLocation = new Location();
      newLocation.label = this.locationNameInput.nativeElement.value;
      this.locationToBeAssignedSuccessEmitter.emit(newLocation);
    } else {
      this.locationToBeAssignedSuccessEmitter
        .emit(this.listOfLocation.find(location => location.id === this.locationListSelect.nativeElement.value));
    }
  }

  onModeOfLocationAssignmentSelectionChange(event) {
    if (event.detail.value === this.createLocationId) {
      this.locationListSelect.nativeElement.value = null;
      this.locationListSelect.nativeElement._markOption(null, false);
      this.locationListSelect.nativeElement.hidden = true;
      this.locationNameInput.nativeElement.hidden = false;
    } else {
      this.locationNameInput.nativeElement.value = '';
      this.locationNameInput.nativeElement.hidden = true;
      this.locationListSelect.nativeElement.hidden = false;
      this.setAttributesOfLocationNameInputNativeElement(false);
    }
  }

  ngAfterViewInit() {
    this.locationNameInput.nativeElement.addEventListener('value-changed', this.validateLocationName.bind(this));
    this.modeOfLocationAssignmentGroup.nativeElement.addEventListener(
      'selected-changed', this.onModeOfLocationAssignmentSelectionChange.bind(this));
    this.modeOfLocationAssignmentGroup.nativeElement.selected = this.selectLocationId;
    this.assignLocationButton.nativeElement.addEventListener('click', this.emitLocationToBeAssignedEvent.bind(this));
  }

  validateLocationName(event) {
    if (event.detail.value.length === 0) {
      this.locationNameInput.nativeElement.setAttribute('error-message', 'Location name is required');
      this.setAttributesOfLocationNameInputNativeElement(true);
      return;
    } else if (this.listOfLocation && this.listOfLocation.some(location => location.label === event.detail.value)) {
      this.locationNameInput.nativeElement.setAttribute('error-message', 'Location name already exists');
      this.setAttributesOfLocationNameInputNativeElement(true);
      return;
    }
    this.setAttributesOfLocationNameInputNativeElement(false);
  }

  isLocationValidToAssign() {
    if (this.modeOfLocationAssignmentGroup.nativeElement.selected === this.createLocationId) {
      return !this.locationNameInput.nativeElement.invalid && !!this.locationNameInput.nativeElement.value;
    } else {
      return !!this.locationListSelect.nativeElement.value;
    }
  }

  private setAttributesOfLocationNameInputNativeElement(setForInvalid: boolean) {
    if (setForInvalid) {
      this.locationNameInput.nativeElement.setAttribute('invalid', '');
    } else {
      this.locationNameInput.nativeElement.removeAttribute('error-message');
      this.locationNameInput.nativeElement.removeAttribute('invalid');
    }
  }

  private loadLocationListNativeElement(isErrorneous: boolean, isProgressResetNotRequired?: boolean) {
    this.locationList.nativeElement.items = this.listOfLocation;
    if (!isProgressResetNotRequired) {
      this.isGetLocationsInProgress = false;
    }
    this.isErrorOccurred = isErrorneous;
  }
}
